import React, { useEffect, useState } from "react";
import Hero from "../components/landing/Hero";
import ScentCarousel from "../components/landing/ScentCarousel";
import ProductSection from "../components/landing/ProductCard";
import BrandProfile from "../components/landing/BrandProfile";
import Footer from "../components/layout/Footer";
import WelcomePopup from "../components/popup/WelcomePopUp"; // ✅ Pastikan nama file benar (huruf besar P di Up)

const Home = () => {
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);

  // ✅ Debug: Auto-show welcome popup on first visit
  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem("sorinPopupSeen");
    console.log("🏠 Home mounted");
    console.log("📦 hasSeenPopup:", hasSeenPopup);
    
    if (!hasSeenPopup) {
      console.log("✅ First visit detected, will show popup in 1.5s");
      const timer = setTimeout(() => {
        console.log("🎉 Showing WelcomePopup now!");
        setShowWelcomePopup(true);
      }, 1500);
      
      return () => {
        console.log("🧹 Cleanup timer");
        clearTimeout(timer);
      };
    } else {
      console.log("❌ Already seen popup, not showing");
    }
  }, []);

  const handleCloseWelcomePopup = () => {
    console.log("🚪 Closing WelcomePopup");
    setShowWelcomePopup(false);
    sessionStorage.setItem("sorinPopupSeen", "true");
  };

  console.log("🔄 Home render, showWelcomePopup:", showWelcomePopup);

  return (
    <main
      style={{
        backgroundColor: "white",
        overflowX: "hidden",
        scrollBehavior: "smooth",
      }}
    >
      <section id="hero">
        <Hero />
      </section>

      <section id="products">
        <ProductSection />
      </section>

      <section id="catalog">
        <ScentCarousel />
      </section>

      <section id="brand">
        <BrandProfile />
      </section>

      <section id="footer">
        <Footer />
      </section>

      {/* ✅ Auto-show popup */}
      {showWelcomePopup && (
        <WelcomePopup onClose={handleCloseWelcomePopup} />
      )}
    </main>
  );
};

export default Home;